import { render } from "./clean-gateway-modal.vue?vue&type=template&id=ecc9983e"
import script from "./clean-gateway-modal.vue?vue&type=script&lang=js"
export * from "./clean-gateway-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__